import usePrivateAxios from '@/common/api/usePrivateAxios'
import {
  CompanyPriceSurveyData,
  CompanyPriceSurveyResponse,
} from '@/features/privateCompanies/types/companyPriceSurvey.type'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

type UseCompanyPriceSurveyProps = {
  id: string
}

type UseCompanyPriceSurveyType = (props: UseCompanyPriceSurveyProps) => UseQueryResult<CompanyPriceSurveyData, unknown>

export const useCompanyPriceSurvey: UseCompanyPriceSurveyType = ({ id }) => {
  const privateAxios = usePrivateAxios()

  return useQuery<CompanyPriceSurveyResponse, unknown, CompanyPriceSurveyData>({
    queryKey: ['companyPriceSurvey', id],
    queryFn: () => {
      return privateAxios.get(`/client/price_surveys/${id}`)
    },
    select: (data) => data?.data?.data,
  })
}
